import { Ref } from 'react'

export const mergeRefs = <T>(node: T, ...refs: (Ref<T> | undefined)[]) => {
  for (const r of refs) {
    if (!r) continue
    if (typeof r === 'function') r(node)
    else (r as React.MutableRefObject<T | null>).current = node
  }
}
